import { useCallback, useMemo } from 'react'
import { FileCode2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchScripts, AUTO_STR as S, type ScriptRow } from './automationApi'

/**
 * A26.11 — Скрипты (песочница). Sandboxed automation scripts. Greenfield:
 * `/admin/automation/scripts` has not shipped yet → fail-soft empty (dormant), and
 * the table lights up automatically when it lands. Placeholder permission USERS_VIEW.
 */
export function ScriptsScreen() {
  const columns = useMemo<AdminColumn<ScriptRow>[]>(
    () => [
      { key: 'name', header: S.name, type: 'text' },
      { key: 'language', header: S.language, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'updated_at', header: S.updatedAt, type: 'text' },
      { key: 'last_run', header: S.lastRun, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchScripts, [])
  return (
    <>
      <PageHeader title={S.scripts} screenId="A26.11" />
      <DataTable<ScriptRow>
        screenId="A26.11"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <FileCode2 size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
